import { Badge } from "react-bootstrap";

export function shouldHave(value: any, defaultValue: string = 'Não configurado') {
    if (value) {
        return value;
    }

    return <span className='text-danger'>{defaultValue}</span>;
}

export function optional(value: any, defaultValue: string = '-') {
    if (value) {
        return value;
    }

    return defaultValue;
}

export function description(value?: string, max = 50) {
    if (value) {
        return value.length > max ? value.substr(0, max) + '...' : value;
    }

    return '-';
}

export function active(value: boolean) {
    return value ? <Badge bg='success' className='p-1'>Ativo</Badge> :
        <Badge bg='danger' className='p-1'>Inativo</Badge>;
}

export function plural(value: number, singular: string, plural: string) {
    return value === 1 ? singular : plural;
}

export function zeros(value: number) {
    return value.toString().padStart(2, '0');
}
